// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610192336/js/" + chunkId + "." + {"44":"62e824b7","225":"63faa9ae","481":"72fc145d","486":"36c96e23","770":"fcb43556"}[chunkId] + ".0.7548413796444515.chunk.js";
};